import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled/base";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Icon } from 'leaflet';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import marker from './images/FaMapMarker.svg';
import './styles.css';
import { Link } from '../../elements';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dgtn380"
} : {
  target: "e1dgtn380",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "q5kz22",
  styles: "position:relative;width:100%;padding-top:50%;.leaflet-container{position:absolute;width:100%;height:100%;top:0;left:0;}"
} : {
  name: "q5kz22",
  styles: "position:relative;width:100%;padding-top:50%;.leaflet-container{position:absolute;width:100%;height:100%;top:0;left:0;}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const LeafletMap = _ref => {
  let {
    address,
    name,
    options,
    showRoute
  } = _ref;
  const {
    0: coordinates,
    1: setCoordinates
  } = useState(null);
  const formattedAddress = `${address.street} ${address.city} ${address.zip_code} ${address.country}`;
  const escapedAddress = encodeURIComponent(`${address.street}+${address.city}+${address.zip_code}+${address.country}`);
  const mapOptions = _objectSpread(_objectSpread({}, options), {}, {
    scrollWheelZoom: false
  });
  const getCoordinatesFromAddress = async () => {
    const provider = new OpenStreetMapProvider();
    let result;
    try {
      result = await provider.search({
        query: formattedAddress
      });
    } catch (e) {
      console.log('Address not found', e);
    }
    if (result) {
      setCoordinates(result[0]);
    }
  };
  useEffect(() => {
    getCoordinatesFromAddress();
    //eslint-disable-next-line
  }, []);
  if (typeof window !== 'undefined' && coordinates) {
    const MapIcon = new Icon({
      iconUrl: marker,
      iconSize: [35, 35],
      iconAnchor: [0, 0],
      popupAnchor: [0, 0]
    });
    return ___EmotionJSX(Container, null, ___EmotionJSX(MapContainer, _extends({}, mapOptions, {
      center: {
        lat: coordinates.y,
        lng: coordinates.x
      },
      zoom: 16
    }), ___EmotionJSX(TileLayer, {
      attribution: "&copy <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    }), ___EmotionJSX(Marker, {
      icon: MapIcon,
      position: {
        lat: coordinates.y,
        lng: coordinates.x
      }
    }, ___EmotionJSX(Popup, null, ___EmotionJSX("div", null, ___EmotionJSX("address", null, name && ___EmotionJSX("p", null, name), ___EmotionJSX("p", null, address.street, ", ", address.city, " ", address.zip_code)), showRoute && ___EmotionJSX(Link, {
      external: true,
      to: `https://www.google.com/maps/dir/?api=1&destination=${escapedAddress}`
    }, "Route planen"))))));
  } else {
    return null;
  }
};
LeafletMap.defaultProps = {
  showRoute: false
};
export default LeafletMap;